export const PickingStatus = {
  SemEntregasAssociadas: {
    label: 'Sem Entregas Associadas',
    color: '#df4747',
  },
  ComEntregasAssociadas: {
    label: 'Com Entregas Associadas',
    color: '#e7be74',
  },
  ProntoParaDownload: {
    label: 'Pronto Para Download',
    color: '#000000',
  },
  ResumoEmitido: {
    label: 'Resumo Emitido',
    color: '#3ac2bb',
  },
  PickingConcluido: {
    label: 'Picking Concluido',
    color: '#57c278',
  },
  ConscluidoParcialmente: {
    label: 'Concluido Parcialmente',
    color: '#cf03fc',
  },
  Expedicao: {
    label: 'Expedição',
    color: '#1ff6ee',
  },
}
export const PickingOcorrencia = {
  ComFalta: {
    label: 'Com Falta',
    color: '#8B0000',
  },
  ComSobra: {
    label: 'Com Sobra',
    color: '#7fc3da',
  },
}

export const OcorrenciaFilter = {
  ComFalta: 'COM FALTA',
  ComSobra: 'COM SOBRA',
  ComFaltaSobra: 'COM FALTA/SOBRA',
}

export const OCORRENCIA_FILTER_OPTIONS = Object.values(OcorrenciaFilter).map(value => ({
  label: value,
  value,
}))

export default function (status) {
  for (const key in PickingStatus) {
    const s = PickingStatus[key]
    if (s.label === status) return PickingStatus[key]
  }
}
